module.exports = __webpack_public_path__ + "img/login-icon.42c284f7.svg";